module.exports = __webpack_public_path__ + "static/media/login_top_right.2a296a1e.svg";